import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { BASE_API_URL } from "../../../../core/environment.tokens";
import { IBulkProjectValidationResult } from "./bulk-project-response.model";

export interface IUploadObject {
  presignedURL: string;
  fileName: string;
}

@Injectable({
  providedIn: "root",
})
export class BulkProjectUploadService {
  creationResult = new BehaviorSubject<IBulkProjectValidationResult>(null);

  constructor(
    @Inject(BASE_API_URL)
    private readonly baseApiUrl: string,
    private readonly http: HttpClient
  ) { }

  getPresignedURL(payload: string): Observable<IUploadObject> {
    const url = `${this.baseApiUrl}presignedurl`;

    return this.http.post(url, payload, { headers: new HttpHeaders({ "Content-Type": "application/json" }) })
      .pipe(map((response: any) => response as IUploadObject));
  }

  uploadFile(url: string, file: File): Promise<boolean> {
    return new Promise((resolve, reject) => {
      try {
        this.http.put(url, file).toPromise().then(() => resolve(true)).catch(reject);
      } catch (e) {
        reject(e);
      }
    });
  }

  startValidation(fileName: string): Observable<IBulkProjectValidationResult> {
    const url = `${this.baseApiUrl}project/bulkvalidate`;

    return this.http.post(url, { fileName })
      .pipe(map((response: any) => response as IBulkProjectValidationResult));
  }

  getValidationStatus(loadId: string): Observable<IBulkProjectValidationResult> {
    const url = `${this.baseApiUrl}project/bulkvalidate/${loadId}`;

    return this.http.get(url)
      .pipe(map((response: any) => response as IBulkProjectValidationResult));
  }

  startCreation(loadId: string): Observable<IBulkProjectValidationResult> {
    const url = `${this.baseApiUrl}project/bulkcreate/${loadId}`;

    return this.http.post(url, {})
      .pipe(map((response: any) => response as IBulkProjectValidationResult));
  }
}
